import React, { Component } from "react";

import Helmet from 'react-helmet';

import SiteLogo from '../pages/images/thumbs/logo.png';

import PanskayaLogo from './images/thumbs/pan.png';
import VirtualBrestLogo from './images/thumbs/vb.png';
import TeleportLogo from './images/thumbs/teleport.png';

import HomePhoto from './images/thumbs/home.png';

import PanskayaLogoBG from './images/thumbs/pan-bg.png';
import VirtualBrestLogoBG from './images/thumbs/vb-bg.png';
import TeleportLogoBG from './images/thumbs/teleport-bg.png';

class Flask extends Component {
    render(){
        return(
            <div id="flask">
                <div className="background"></div>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 113 130" xmlSpace="preserve">
                    <g>
                        <path fill="#f6f6f6" d="M0,0v130h112.084L111.75,0H0z M94.75,128C71,128,56,128,56,128s-14.873,0-38.623,0s-13.945-19.422-6.33-35.945S40,41.25,40,41.25V3h16h11v38.25c0,0,23.901,34.283,31.517,50.805S118.5,128,94.75,128z"/>
                        <path fill="none" stroke="#000000" strokeWidth="4" strokeMiterlimit="10" d="M56,127.5c0,0-14.873,0-38.623,0s-13.695-19.172-6.08-35.695C18.912,75.283,40.5,41.25,40.5,41.25V2.5h-9H56h19.5h-8v38.75c0,0,23.651,34.033,31.267,50.555c7.615,16.523,19.733,35.695-4.017,35.695S56,127.5,56,127.5z"/>
                    </g>
                </svg>
                <div className="bubble b0"></div>
                <div className="bubble b1"></div>
                <div className="bubble b2"></div>
                <div className="bubble b3"></div>
                <div className="bubble b4"></div>
                <div className="bubble b5"></div>
                <div className="bubble b6"></div>
                <div className="bubble b7"></div>
                <div className="bubble b8"></div>
                <div className="bubble b9"></div>
                
                <div className="swirl s0"></div>
                <div className="swirl s1"></div>
                <div className="swirl s2"></div>
                <div className="swirl s3"></div>
                <div className="swirl s4"></div>
                <div className="swirl s5"></div>
            </div>
        );
    }
}

class Index extends Component {

  render(){

    const Portfolio = [
        {name: 'Агроусадьба "Панская"', imglogo: PanskayaLogo, img: PanskayaLogoBG, link: 'http://panskaya.by', description: 'Сайт-визитка'},
        {name: 'Виртуальный Брест', darkText: true, imglogo: VirtualBrestLogo, img: VirtualBrestLogoBG, link: 'https://play.google.com/store/apps/details?id=com.virtualbrest', description: 'Мобильное приложение "Виртуальный Брест"'},
        {name: 'TELEPORT', imglogo: TeleportLogo, img: TeleportLogoBG, link: 'https://voblako.com/', description: 'Сеть онлайн камер'}
    ]

      return (
      <div>
      <Helmet
        title={'Postoyalko Anton, front-end web developer'}
        meta={[
          {"name": "description", "content": "Postoyalko Anton portfolio site"},
          {"name": "keywords", "content": "Ufon, ufon-site, portfolio ufon, anton postoyalko site, антон постоялко, портфолио антон постоялко, ufon.brest.by"},
          {"property": "og:image", "content": {SiteLogo}},
          {"property": "og:title", "content": "Postoyalko Anton, front-end web developer"},
          {"property": "og:url", "content": "https://ufon.brest.by"},
          {"property": "og:site_name", "content": "ufon.brest.by"},
          {"property": "og:type", "content": "website"}
        ]}
      />
      <div className="home-container">
          <div className="row ">
                            <div className="col-8 ">
              <div className="home-main-image">

                <img src={HomePhoto} alt="Anton Postoyalko"/>

              </div>
              </div>
              <div className="col-4">
                  <div className="home-text-block" >
                      <div className="home-text-block__header">
                          
                          <h2>Postoyalko Anton,</h2>
                          <p>front-end developer</p>
                          <Flask/>
                      </div>
                      {/* <div className="home-text-block__inner">
                          
                          
                      </div> */}
                  </div>
              </div>

          </div>
          <br/>
          <br/>
          <div className="row" >

              {Portfolio.map((item, index)=>
              <div key={index} className="col-4">
                  <div className="grid">
                      <figure className="effect-selena">
                          <img src={item.img} alt={item.name}/>
                          <figcaption>
                              <div className="img-wrapper"><img src={item.imglogo} alt={item.name}/></div>
                              <p style={{color: (item.darkText) ? '#333447' : 'white' }}>{item.description}</p>
                              <a href={item.link}>Перейти на сайт.</a>
                          </figcaption>			
                      </figure>
                  </div>
              </div>
              )}

          </div>
          <h3>Hi! I'm 19 years old. I live in Brest, Belarus.<br/> I'm passionate about design and music.</h3>
          <p>In my free time I read various articles and books, learn english, <br/> play with new technologies, and search pretty music.<br/><br/>
            Since 2014 I have a big expirience in front / back - end developing. <br/> Now, I'm studying at the Brest State Technical University.</p>
      </div>
      </div>
      );
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/pages/index.js